import {
  createPlugin,
  createRoutableExtension,
  createComponentExtension,
  createApiFactory,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { adManagementApiRef, AdManagementClient } from './api/AdManagementClient';
import { rootRouteRef } from './routes';

export const adManagementPlugin = createPlugin({
  id: 'ad-management',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: adManagementApiRef,
      deps: { fetchApi: fetchApiRef },
      factory: ({ fetchApi }) => new AdManagementClient({ fetchApi }),
    }),
  ],
});

export const AdManagementPage = adManagementPlugin.provide(
  createRoutableExtension({
    name: 'AdManagementPage',
    component: () =>
      import('./components/AdManagementPage').then(m => m.AdManagementPage),
    mountPoint: rootRouteRef,
  }),
);

export const MyGpgKeyCard = adManagementPlugin.provide(
  createComponentExtension({
    name: 'MyGpgKeyCard',
    component: {
      lazy: () =>
        import('./components/MyGpgKeyCard').then(m => m.MyGpgKeyCard),
    },
  }),
);
